import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MobileNav } from './MobileNav';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const CLAVE_COLAPSADO = 'eventos-cien:sidebar-colapsado';

/** Shell principal de la app: Sidebar + Topbar + el contenido de cada ruta. */
export function AppLayout() {
  const [colapsado, setColapsado] = useState(() => {
    try {
      return localStorage.getItem(CLAVE_COLAPSADO) === '1';
    } catch {
      return false;
    }
  });
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(CLAVE_COLAPSADO, colapsado ? '1' : '0');
    } catch {
      // localStorage puede fallar (modo privado); no es critico.
    }
  }, [colapsado]);

  return (
    <div className="flex min-h-dvh bg-fondo">
      <Sidebar colapsado={colapsado} onToggle={() => setColapsado((v) => !v)} />
      <MobileNav abierto={menuAbierto} onCerrar={() => setMenuAbierto(false)} />

      <div className="flex min-h-dvh flex-1 flex-col overflow-x-hidden">
        <Topbar onAbrirMenu={() => setMenuAbierto(true)} />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
